module.exports = __webpack_public_path__ + "basket.png";